import withNavigate from "../../../routes/withNavigate.jsx";
import CustomerMasterContainer from "./CustomerMasterContainer.jsx";
import CustomerMasterStore from "./CustomerMasterStore.js";

export default CustomerMasterStore(withNavigate(CustomerMasterContainer));
